import { signMessage } from '../handlers/walletActions/wallet'

const BASE_URL = 'https://ai.plug-wallet.com/v1'

export interface Bubble {
  message: string
  emoji: string
}

export interface Message {
  role: 'user' | 'assistant'
  content: string
}

interface ChatContext {
  auth: string
  question: string
  sessionId: string
  userBalances: {
    token: string
    balance: number
    currencySymbol: string
  }[]
  history: Message[]
  principalId: string
  accountId: string
}

export class PlugIntelligenceClient {
  private static async fetch(
    path: string,
    method: 'GET' | 'POST' = 'GET',
    body?: any,
    auth?: string,
    textStreaming?: boolean
  ) {
    let headers: HeadersInit | undefined = undefined
    if (body || auth) {
      headers = {}

      if (body) headers['Content-Type'] = 'application/json'
      if (auth) headers.Authorization = auth
    }

    return fetch(BASE_URL + path, {
      method,
      body: body ? JSON.stringify(body) : undefined,
      headers,
      // @ts-ignore
      reactNative: { textStreaming },
    })
  }

  static async isAvailable(): Promise<boolean> {
    try {
      const response = await this.fetch('/is-available')

      return response.ok
    } catch {
      return false
    }
  }

  static async getInitialMessage(): Promise<string> {
    const response = await this.fetch('/initial-message')

    if (response.ok) {
      return response.text()
    } else {
      throw response
    }
  }

  static async getBubbles(): Promise<Bubble[]> {
    const response = await this.fetch('/bubbles')

    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }

  static async chat({ auth, ...context }: ChatContext): Promise<Response> {
    return this.fetch('/chat', 'POST', context, auth, true)
  }

  static async authenticate(principalId: string): Promise<string> {
    const response = await this.fetch('/auth/nonce', 'POST', { principalId })

    if (response.ok) {
      const { nonce } = await response.json()
      const signedNonce = await signMessage(principalId, nonce)
      const auth = await this.fetch('/auth', 'POST', signedNonce)

      const { jwt } = await auth.json()
      return jwt
    } else {
      throw response
    }
  }
}
